import { ErrorNote, Facts, Loading, PageHead, Section } from "../components/kit";
import type { Settings } from "../lib/api";
import { useResource } from "../lib/hooks";
import { SMSSettings } from "./SMSSettings";

export function SettingsPage() {
  const { data, error } = useResource<Settings>("/settings");
  return (
    <>
      <PageHead
        title="Configuration"
        lede="The services the sign-on depends on. Credentials entered here are sealed on the server and never shown again."
      />
      <ErrorNote error={error} />
      <SMSSettings />
      <Section title="Single sign-on" aside={<span className="muted small">Set on the server, read-only here</span>}>
        {data ? (
          <Facts
            items={[
              ["Issuer", <code key="i">{data.issuer}</code>],
              ["Discovery", <code key="d">{data.discovery_url}</code>],
              ["This panel", <code key="p">{data.panel_url}</code>],
              [
                "Signing key",
                <span key="k">
                  <code>OIDC_SIGNING_KEY</code> in shared/api.env, rotated through <code>OIDC_PREVIOUS_SIGNING_KEY</code>
                </span>,
              ],
            ]}
          />
        ) : (
          <Loading />
        )}
      </Section>
    </>
  );
}
